import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({ baseURL: `${API}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('misel_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('misel_token');
      localStorage.removeItem('misel_user');
      if (!window.location.pathname.includes('/auth/')) {
        window.location.href = '/auth/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
export { API };
